import { Controller } from "@hotwired/stimulus"

/**
 * 繰越処理画面用のStimulusコントローラー
 */
export default class extends Controller {
  static targets = ["branchSelect", "lastCarryForwardContainer", "lastCarryForwardText", "branchIdField"]

  /**
   * センター選択が変更されたときに前回繰越日時を更新
   */
  async updateLastCarryForward() {
    const branchId = this.branchSelectTarget.value

    // 「--指定なし--」を選択した場合は非表示
    if (!branchId) {
      this.lastCarryForwardContainerTarget.classList.add('hidden')
      return
    }

    try {
      const response = await fetch(`/carry_forwards/last_carry_forward?branch_id=${branchId}`, {
        headers: {
          'Accept': 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        }
      })

      if (!response.ok) {
        throw new Error('Network response was not ok')
      }

      const data = await response.json()
      this.lastCarryForwardTextTarget.textContent = data.formatted_text
      this.lastCarryForwardContainerTarget.classList.remove('hidden')
    } catch (error) {
      console.error('Error fetching last carry forward:', error)
      this.lastCarryForwardTextTarget.textContent = '-'
      this.lastCarryForwardContainerTarget.classList.remove('hidden')
    }
  }

  /**
   * フォーム送信前にhidden fieldを更新
   */
  submitForm(event) {
    const hour = new Date().getHours()
    if (hour < 12) {
      if (!confirm('午前中の繰越処理となります。前営業日の繰越処理が実施されていない場合か、その他必要な事情がある場合に限り実行してください。')) {
        event.preventDefault()
        return
      }
    }
    if (!confirm('繰越処理を実行します')) {
      event.preventDefault()
      return
    }
    if (this.hasBranchIdFieldTarget && this.branchSelectTarget) {
      this.branchIdFieldTarget.value = this.branchSelectTarget.value
    }
  }
}
